import useApi from '../api';

const useDashboardCoursesService = () => {
    const { api } = useApi();

    return {
        getDashboardCourses: (year, month = null, enterpriseId) =>
            api.get(`courses/metrics`, {
                params: {
                    year,
                    month,
                    enterpriseId
                }
            }),
        getDashboardCoursesBarGraph: (year, enterpriseId) =>
            api.get(`courses/bar-graph`, {
                params: {
                    year,
                    enterpriseId
                }
            }),
        getConsultantCoursesMetrics: (year, month = null, enterpriseId, perPage, page) =>
            api.get(`courses/consultant-metrics`, {
                params: {
                    year,
                    month,
                    enterpriseId,
                    perPage,
                    page
                }
            }),
        getConsultantCoursesMetricsExport: (year, month = null, enterpriseId, perPage, page) =>
            api.get(`courses/consultant-metrics-export`, {
                params: {
                    year,
                    month,
                    enterpriseId
                },
                responseType: 'blob'
            })
    };
};

export default useDashboardCoursesService;
